// Notificaciones globales (window.notifications): las usan main.js, inits.js y el WS
const notifications = window.notifications = {

  formatMessage (msg) {
    if (Array.isArray(msg)) return msg.join('\n')
    if (msg && typeof msg === 'object') return Object.entries(msg).map(([key, value]) => key + ': ' + value).join('\n')
    return msg
  },

  // type: warning, error, success, info
  showNoty (text, type, timeout) {
    if (window.Toast) {
      window.Toast.addNotification({ text, type, timeout })
    } else {
      window.ToastCache = window.ToastCache || []
      window.ToastCache.push({ text, type, timeout })
    }
  },

  showSuccessNoty (msg, timeout = 3000) {
    this.showNoty(this.formatMessage(msg), 'success', timeout)
  },

  showInfoNoty (msg, timeout = 3000) {
    this.showNoty(this.formatMessage(msg), 'info', timeout)
  },

  showWarningNoty (msg, timeout = 10000) {
    this.showNoty(this.formatMessage(msg), 'warning', timeout)
  },

  showErrorNoty (msg, timeout = 60000) {
    this.showNoty(this.formatMessage(msg), 'error', timeout)
  },

  // Pantalla de carga inicial (#loader-cover de index.html)
  blockScreen () {
    document.getElementById('loader-cover').style.display = 'flex'
  },

  unblockScreen () {
    document.getElementById('loader-cover').style.display = 'none'
  }
}

export default notifications
